export default __webpack_public_path__ + "static/media/maxine_detail10.6ac34aa1.jpg";